export default __webpack_public_path__ + "static/media/imageOderBuy.543138a1.svg";